export const USER_MAIL = 'USER_MAIL';
export const USER_MOB = 'USER_MOB';
export const USER_CURRENT_PROFILE = 'userCurrentProfile';
export const AGGREGATED_USER_DETAILS = 'AGGREGATED_USER_DETAILS';
export const ID = 'ID';
